<template>
  <div
    v-if="isVisible"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4 z-50"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3 class="ml-6 mt-7 mb-5">
        {{ $t('messages.email_change_success.title') }}
      </h3>
      <p class="ml-6 mr-6 mb-10 text-zyxel-gray-800">
        {{ $t('messages.email_change_success.description') }}
      </p>
      <div class="flex px-4 sm:px-0 sm:justify-end sm:space-x-2 sm:mr-6 mb-9">
        <button
          class="w-full sm:w-auto sm:min-w-[120px] button-primary"
          @click="logout"
        >
          {{ $t('messages.button.ok') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "EmailChangeSuccessDialog",
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    logout() {
      this.$emit('logout');
    }
  }
}
</script>